import { Toaster } from 'lib/Toaster';
import { useDispatch, useSelector } from 'react-redux';
import { Store } from 'components/common/types/Store.types';
import { removeToastNotification } from 'store/notification/reducer';

export const AppToaster: React.FC = () => {
  const dispatch = useDispatch();
  const toastNotifications = useSelector((state: Store) => state.notification);

  const onToastRemove = (toastId: string): void => {
    dispatch(removeToastNotification(toastId));
  };

  return <Toaster toasts={toastNotifications} onToastRemove={onToastRemove} />;
};
